<!-- ChatRoom.vue -->
<template>
  <div class="chatroom-container">
    <div class="chatroom">
      <div class="sidebar">
        <div class="user-profile">
          <el-avatar :size="40" :src="head_url"></el-avatar>
          <span class="user-name">{{ username }}</span>
        </div>
        <el-menu
          :default-active="`${currentRoomId}`"
          class="friend-list"
          background-color="#ffffff"
          text-color="#000000"
          active-text-color="#f3f3f3"
          @select="handleSelect"
        >
          <el-menu-item
            :index="friend_item.room_id.toString()"
            v-for="friend_item in friendList"
            :key="friend_item.room_id"
            class="friend-item"
          >
            <el-avatar
              :size="40"
              :src="friend_item.avatar"
              class="friend-avatar"
            ></el-avatar>
            <div class="content">
              <div class="conversation">
                <div class="name">{{ friend_item.name }}</div>
                <div class="status online"></div>
                <div class="time">{{ friend_item.time }}</div>
              </div>
              <div class="conversation-secondary-line">
                <div class="desc">{{ friend_item.content }}</div>
                <div v-if="friend_item.unread_num > 0" class="unread-badge">
                  {{ friend_item.unread_num }}
                </div>
              </div>
            </div>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="chat-area">
        <div class="chat-header">
          <!-- 聊天头部，显示聊天对象名称和选项 -->
          <div class="header-title">
            {{ friendList[currentRoomId].name }}
            <span v-if="friendList[currentRoomId].is_public"
              >（{{ friendList[currentRoomId].online_user_count }}）</span
            ><span
              v-if="isTyping && friendList[currentRoomId].is_public == 0"
              >{{ typingMessage }}</span
            >
          </div>
        </div>
        <div class="message-area" ref="messageArea">
          <!-- 显示消息的区域 -->
          <div
            v-for="message in messages[currentRoomId]"
            :class="{
              'message-left': message.type === 'received',
              'message-right': message.type === 'sent',
              'message-center': message.type === 'system',
            }"
            @mouseover="message.showChatButton = true"
            @mouseleave="message.showChatButton = false"
          >
            <template v-if="message.type !== 'system'">
              <div class="message-avatar">
                <el-avatar
                  :size="40"
                  :src="message.avatar"
                  class="friend-avatar"
                ></el-avatar>
              </div>
              <div class="message-content">
                <div class="message-header">
                  <div class="message-name" v-if="message.type === 'received'">
                    {{ message.name }}
                  </div>
                  <div class="message-time">{{ message.time }}</div>
                  <div class="start-chat-container">
                    <el-button
                      v-if="
                        message.type === 'received' &&
                        message.showChatButton &&
                        friendList[currentRoomId].is_public == 1
                      "
                      type="primary"
                      size="mini"
                      round
                      class="start-chat-button"
                      @click="
                        createRoom(
                          message.user_id,
                          message.name,
                          message.avatar
                        )
                      "
                    >
                      发起聊天
                    </el-button>
                  </div>
                </div>
                <div class="message-text-container">
                  <div class="message-text">
                    <div v-if="message.content == ''" class="dot-elastic"></div>
                    {{ message.content }}
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <!-- 系统消息的布局 -->
              <div class="system-message-content">
                <div class="system-message-text">{{ message.content }}</div>
              </div>
            </template>
          </div>
        </div>
        <div class="chat-footer">
          <!-- 输入消息的区域 -->
          <div class="chat-textarea">
            <textarea
              placeholder="请输入内容"
              v-model="newMessage"
              @input="showTyping"
              @keyup.enter="sendMessage"
              class="newMessageTextarea"
              autocomplete="off"
            ></textarea>
          </div>
          <el-button
            type="primary"
            size="small"
            round
            @click="sendMessage"
            :disabled="!newMessage.trim()"
            >发送</el-button
          >
        </div>
      </div>
    </div>
    <div class="network-status-container">
      <!-- 引入 NetworkInfo 组件 -->
      <NetworkInfo class="network-status"></NetworkInfo>
    </div>
  </div>
</template>


<script>
import api from "@/services/api";
import "@/assets/css/dot.css";
import NetworkInfo from "./NetworkInfo.vue";

export default {
  name: "ChatRoom",
  metaInfo: {
    title: "IM聊天室", // 设置页面标题
    meta: [
      { name: "description", content: "大鸡排工作室出品！" }, // 设置页面描述
    ],
  },
  data() {
    return {
      username: "",
      head_url: "",
      user_id: 0,
      currentRoomId: 0,
      messages: { 1: [], 0: [] },
      friendList: {
        1: {
          room_id: 1,
          avatar: "http://resource.djp.org.cn/images/head_default.png",
          name: "聊天大厅",
          online_status: 1,
          time: "",
          content: "",
          unread_num: 0,
          is_public: 1,
          online_user_count: 0,
        },
        0: {
          room_id: 0,
          avatar: "http://resource.djp.org.cn/images/ai_avatar.png",
          name: "AI助手",
          online_status: 1,
          time: "",
          content: "",
          unread_num: 0,
          is_public: 0,
          online_user_count: 0,
        },
      },
      newMessage: "",
      isTyping: false,
      typingTimeout: null,
      isPublic: 1, // 是否群聊
      onlineUserCount: 0, // 群聊在线人数
    };
  },
  components: { NetworkInfo },
  mounted() {
    this.getUserInfo();
    this.connect();
  },
  methods: {
    // 获取用户信息
    getUserInfo() {
      // todo 可以使用惰性函数优化下代码
      var token = $cookies.get("token");
      if (token && token != "") {
        // 已登录
        this.username = $cookies.get("username");
        this.head_url = $cookies.get("head_url");
        this.user_id = $cookies.get("user_id");
      } else {
        //未登录
        // this.$router.push({ path: "/" });
      }
    },

    // ws连接
    connect() {
      // Replace 'localhost' with your server's IP address if needed
      const token = $cookies.get("token");
      const WEBSOCKET_SERVER = process.env.WEBSOCKET_SERVER;
      this.ws = new WebSocket(WEBSOCKET_SERVER + "?token=" + token);

      this.ws.onopen = () => {
        console.log("ws连接成功！");
      };

      // ws消息响应
      this.ws.onmessage = (event) => {
        var message = JSON.parse(event.data);
        const { chat_msg_type, data, msg_type } = message;
        console.log(chat_msg_type, data, msg_type);
        message.data.created_at = this.formatTime(message.data.created_at);
        // 判断是系统消息还是用户消息
        switch (msg_type) {
          case 1:
            this.upSystemMsg(data);
            break;
          case 2:
            // 更新聊天区消息
            this.upUserMsg(data);
            // 更新好友列表的最新消息
            this.upListMsg(data);
            break;
          case 3:
            // 发起私聊
            this.upFriendList(data);
            if (this.user_id == data.from_user_id) {
              this.currentRoomId = data.room_id;
            }
            break;
          default:
            console.log(msg_type, data);
        }

        // 消息区滚动到底部
        this.$nextTick(() => {
          setTimeout(() => {
            this.scrollToBottom();
          }, 100); // 延迟100ms执行滚动
        });
      };

      // ws连接断开
      this.ws.onclose = (event) => {
        console.log("WebSocket 连接失败，尝试重连...");
        console.log("Connection closed. Reason: " + event.reason);
        setTimeout(() => {
          this.connect();
          this.getUserInfo();
        }, 1000);
      };

      // ws错误处理
      this.ws.onerror = (error) => {
        console.error("WebSocket Error: ", error);
      };
    },

    // 更新用户消息
    upUserMsg(data) {
      // 判断消息是发送还是接收
      var messageName = data.username;
      var messageAvatar = data.avatar;
      var messageType = "";
      if (data.from_user_id == this.user_id) {
        messageType = "sent";
      } else {
        messageType = "received";
      }
      // 如果是消息集未包含该房间，则初始化该房间消息集
      if (!this.messages.hasOwnProperty(data.room_id)) {
        this.messages[data.room_id] = [];
      }
      // 如果好友列表中未包含该消息所属房间，则新增好友列表
      if (!this.friendList.hasOwnProperty(data.room_id)) {
        this.friendList[data.room_id] = {
          room_id: data.room_id,
          avatar: data.avatar,
          name: data.username,
          online_status: 1,
          time: data.created_at,
          content: data.content,
          unread_num: 1,
          is_public: 0,
          online_user_count: 2,
        };
      }
      this.messages[data.room_id].push({
        user_id: data.from_user_id,
        name: messageName,
        avatar: messageAvatar,
        content: data.content,
        time: data.created_at,
        type: messageType,
        showChatButton: false,
      });
    },

    //更新好友列表最新消息
    upListMsg(data) {
      if (this.friendList.hasOwnProperty(data.room_id)) {
        console.log("房间存在", this.friendList[data.room_id]);
        // 键存在，更新内容和时间
        this.friendList[data.room_id].content = data.content;
        this.friendList[data.room_id].time = data.created_at;
        console.log(this.friendList[data.room_id]);
      } else {
        console.log("房间不存在");
        // 键不存在，添加新的键值对
        this.friendList[data.room_id] = {
          content: data.content,
          time: data.created_at,
        };
      }
    },
    // 更新好友列表
    upFriendList(data) {
      if (this.user_id == data.from_user_id) {
        this.friendList[data.room_id] = {
          room_id: data.room_id,
          avatar: data.to_user_avatar,
          name: data.to_user_name,
          online_status: 1,
          time: data.created_at,
          content: data.content,
          unread_num: 0,
          is_public: 0,
          online_user_count: 2,
        };
      }
    },

    //
    handleSelect(roomId) {
      this.currentRoomId = roomId;
    },

    // 更新系统消息
    upSystemMsg(data) {
      this.messages[data.room_id].push({
        content: data.content,
        type: "system",
      });
      // 更新在线人数
      this.friendList[data.room_id].online_user_count = data.oneline_user_count;
    },

    // 发送消息
    sendMessage() {
      if (
        this.currentRoomId != 0 &&
        this.ws &&
        this.ws.readyState === WebSocket.OPEN &&
        this.newMessage.trim() !== ""
      ) {
        // 创建要发送的消息对象
        let messageObject = {
          msg: {
            chat_msg_type: 1, // 设置为群聊
            msg_type: 2, // 用户发送消息
            data: {
              room_id: this.currentRoomId,
              content: this.newMessage, // 用户输入的内容
              avatar: this.head_url,
              username: this.username,
            },
          },
        };

        // 将消息对象转换为JSON字符串
        this.ws.send(JSON.stringify(messageObject));

        // 清空输入框
        this.newMessage = "";
      } else if (this.currentRoomId == 0) {
        this.askAI(this.newMessage);
      } else {
        console.log("WebSocket is not connected.");
      }
    },

    // AI助手对话
    askAI(question) {
      this.messages[0].push({
        user_id: this.user_id,
        name: this.username,
        avatar: this.head_url,
        content: question,
        time: this.formatTime(),
        type: "sent",
        showChatButton: false,
      });
      // 清空输入框
      this.newMessage = "";
      this.messages[0].push({
        avatar: this.friendList[0].avatar,
        content: "",
        time: "",
        type: "received",
        showChatButton: false,
      });
      var AIloading = true;
      api.askQuestion(question).then((res) => {
        const { code, data } = res;
        if (code == 200 && AIloading) {
          // 找到最后一个元素的索引
          const lastIndex = this.messages[0].length - 1;
          // 更新最后一个元素的属性
          console.log(this.messages[0]);
          this.messages[0][lastIndex].avatar = this.friendList[0].avatar;
          this.messages[0][lastIndex].content = data.answer;
          this.messages[0][lastIndex].time = this.formatTime();
          this.messages[0][lastIndex].type = "received";
          this.messages[0][lastIndex].showChatButton = false;
          AIloading = false;
        }
      });
    },

    // 发起私聊
    createRoom(to_user_id, to_user_name, to_user_avatar) {
      if (this.ws && this.ws.readyState === WebSocket.OPEN) {
        // 创建要发送的消息对象
        let messageObject = {
          msg: {
            chat_msg_type: 1, // 设置为群聊
            msg_type: 3, // 用户发送消息
            data: {
              content: this.newMessage, // 用户输入的内容
              from_user_id: parseInt(this.user_id), // 发起人id
              from_user_name: this.username,
              to_user_id: parseInt(to_user_id), // 接受人id
              to_user_name: to_user_name,
              to_user_avatar: to_user_avatar,
            },
          },
        };

        // 将消息对象转换为JSON字符串
        this.ws.send(JSON.stringify(messageObject));
      } else {
        console.log("WebSocket is not connected.");
      }
    },

    // 消息区始终位于底部
    scrollToBottom() {
      const container = this.$refs.messageArea;
      container.scrollTop = container.scrollHeight;
    },

    // 格式化时间
    formatTime(isoString) {
      if (!isoString) {
        // 如果没有提供时间戳，则使用当前时间
        isoString = new Date().toISOString();
      }
      const date = new Date(isoString);
      const options = {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      };
      return new Intl.DateTimeFormat("default", options).format(date);
    },

    showTyping() {
      // if (this.typingTimeout) {
      //   clearTimeout(this.typingTimeout);
      // }
      // this.isTyping = true;
      // this.typingTimeout = setTimeout(() => {
      //   this.isTyping = false;
      // }, 1000);
    },
  },

  computed: {
    typingMessage() {
      return "正在输入中...";
    },
  },

  beforeDestroy() {
    if (this.ws) {
      this.ws.close();
    }
  },
};
</script>

<style scoped>
.chatroom-container {
  display: flex; /* 启用flex布局 */
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  height: 100vh; /* 容器高度为视窗的100% */
  width: 100vw; /* 容器宽度为视窗的100% */
  background-color: #f0f0f0; /* 背景颜色，根据实际情况调整 */
}

.chatroom {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); /* 添加一些阴影，让它更有立体感 */
  border-radius: 8px; /* 圆角边框 */
  overflow: hidden; /* 如果内容超出，则隐藏 */
  width: 80%; /* 聊天室宽度，根据实际需要调整 */
  max-width: 1000px; /* 最大宽度，避免在大屏幕上过宽 */
  height: 80%; /* 聊天室高度，根据实际需要调整 */
  max-height: 800px; /* 最大高度 */
  background-color: #ffffff; /* 设置背景颜色 */
  display: flex;
  flex-direction: row; /* 定义flex子项的排列方向为水平布局 */
}

.sidebar {
  width: 30%; /* 占总宽度的30% */
  background-color: #f6f6f6 !important; /* 侧边栏背景色 */
  /* 其他样式... */
}

.user-profile {
  display: flex;
  padding: 10px 0;
  justify-content: center;
  flex-direction: row;
}
.user-name {
  margin: auto 10px;
  text-align: center;
}
.friend-list {
  display: flex;
  flex-direction: column;
}
.friend-list .is-active {
  background-color: #f3f3f3 !important;
}
.el-menu-item {
  line-height: normal;
}
.friend-item {
  display: flex;
  flex-direction: row;
  padding-left: 0 !important;
  color: #787a7f !important;
  height: 56px;
}
.friend-avatar {
  margin: auto;
}
.content {
  margin-left: auto;
  width: 80%;
  display: flex;
  flex-direction: column;
}
.conversation {
  display: flex;
  flex-direction: row;
  padding: 6px 0;
}
.conversation .name {
  color: #000;
  font-weight: bold;
}
.status {
  width: 10px; /* 状态点的大小 */
  height: 10px;
  border-radius: 50%; /* 创建圆形 */
  display: inline-block; /* 使其与文本在一行显示 */
  margin-left: 5px; /* 在点和名字之间添加一些间隔 */
  vertical-align: middle; /* 垂直居中对齐 */
  margin-right: auto;
  margin-top: auto;
  margin-bottom: auto;
}

.online {
  background-color: green; /* 在线状态为绿色 */
}
.offline {
  background-color: gray; /* 不在线状态为灰色 */
}
.conversation .time {
  margin-left: auto;
}
.conversation-secondary-line {
  display: flex;
  flex-direction: row;
  margin-top: auto;
}
.desc {
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.unread-badge {
  margin-left: auto;
  background-image: linear-gradient(121deg, #ff602d, #ff4000 93%);
  border-radius: 7px;
  color: #fff;
  font-size: 10px;
  height: 14px;
  letter-spacing: 0;
  line-height: 14px;
  width: 14px;
}

.chat-area {
  width: 70%; /* 占总宽度的70% */
  display: flex;
  flex-direction: column; /* 子元素垂直排列 */
  /* 其他样式... */
}

.chat-header {
  background-color: #f3f3f3; /* 聊天头部背景色 */
  height: 40px;
  width: 100%;
  /* 需要根据实际内容设置合适的高度或padding */
  display: flex;
  align-items: center; /* 垂直居中 */
  padding-left: 10px;
  position: relative;
  padding-top: 5px;
  padding-bottom: 5px; /* 留出空间给分割线 */
}

.chat-header::after {
  content: ""; /* 重要：这使得伪元素生效 */
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0; /* 分割线位于chat-header底部 */
  height: 1px; /* 分割线的高度 */
  background-color: #dedede; /* 分割线的颜色 */
}

.message-area {
  flex-grow: 1; /* 占据剩余空间 */
  background-color: #f3f3f3; /* 消息区域背景色 */
  /* 其他样式... */
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 20px 10px;
}
.message-header {
  display: flex;
  flex-direction: row;
}
.message-content {
  margin: 0 10px;
}

.message-left,
.message-right {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.message-left .message-content,
.message-right .message-content {
  max-width: 70%;
}

.message-left {
  flex-direction: row;
}

.message-right {
  flex-direction: row-reverse;
}

.message-name {
  font-weight: bold;
}

.message-time {
  font-size: 12px;
  color: gray;
  margin-top: auto;
  margin-bottom: auto;
}
.message-time {
  margin-left: 5px;
}
.start-chat-container {
  margin-left: 5px;
}
.message-text-container {
  display: inline-block; /* 将容器设为内联块级元素 */
  max-width: 100%;
}

.message-left:hover .start-chat-button {
  display: inline-block;
}

/* 对话框通用样式 */
.message-text {
  min-width: 45px;
  margin-top: 5px;
  text-emphasis: left;
  padding: 10px;
  border-radius: 10px;
  position: relative;
}

.message-left .message-content {
  text-align: left; /* 左对齐 */
}

.message-right .message-content {
  text-align: right; /* 右对齐 */
}

/* 接收的消息（左边） */
.message-left .message-text {
  background-color: white;
  border: 1px solid white; /* 添加边框 */
}

/* 发送的消息（右边） */
.message-right .message-text {
  background-color: #90ee90; /* 淡绿色背景 */
  border: 1px solid #90ee90; /* 边框与背景色一致 */
}

/* 消息小尾巴效果 */
.message-left .message-text::after {
  content: "";
  position: absolute;
  top: 50%;
  left: -10px; /* 小尾巴位置 */
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-right-color: white;
  border-left: 0;
  margin-top: -5px;
  z-index: 0;
}

.message-right .message-text::after {
  content: "";
  position: absolute;
  top: 50%;
  right: -10px; /* 小尾巴位置 */
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-left-color: #90ee90;
  border-right: 0;
  margin-top: -5px;
  z-index: 0;
}

.message-center {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 4px 0;
}

.system-message-content {
  background-color: #f0f0f0;
  padding: 2px 16px;
  border-radius: 12px;
}

.system-message-text {
  font-size: 14px;
  color: #555;
}

.chat-footer {
  height: 25%;
  width: 100%;
  /* 需要根据实际内容设置合适的高度或padding */
  display: flex;
  align-items: stretch; /* 确保子元素撑满容器高度 */
  flex-direction: column;
}

.chat-textarea {
  flex-grow: 1; /* 输入框占据剩余空间 */
}
.el-textarea {
  height: 100%;
}

.newMessageTextarea {
  resize: none; /* 移除可扩拽标记 */
  height: 100%; /* 撑满容器高度 */
  width: 100%;
  box-sizing: border-box; /* 边框和内边距包含在宽度和高度内 */
  overflow-y: auto; /* 内容过长时显示滚动条 */
  border: none;
  outline: none;
  padding: 10px;
}

.el-button {
  background-color: orange;
  border: none;
}
.chat-footer .el-button {
  flex-shrink: 0; /* 防止按钮大小调整 */
  width: 80px;
  margin-left: auto;
  margin-right: 10px;
  margin-bottom: 10px;
}

.start-chat-button {
  padding: 4px 6px !important;
}

.network-status-container1 {
  background-color: orange;
  width: 100px;
  height: 100px;
  position: absolute;

  font-size: 10px;
}

.network-status {
  position: fixed;
  bottom: 80px;
  right: 20px;
  background-color: orange;
  font-size: 8px;
  width: 85px; /* 设置宽度 */
  height: 85px; /* 设置高度 */
  padding: 10px;
  border-radius: 50%; /* 将边框设置为圆形 */
}

.network-status-info p {
  margin: 2px !important;
}

@media screen and (max-width: 680px) {
  .friend-avatar {
    display: none;
  }
}

@import "@/assets/css/dot.css";
</style>



// WEBPACK FOOTER //
// src/components/ChatRoom.vue